const options = {
  compact: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export function getSearchRange(value) {
  const base = 10 ** Math.floor(Math.log10(value));

  return {
    ceil: base * 10,
    floor: base < 10 ? 0 : base,
  };
}

export function getSearchRangeString(value, i18n) {
  const range = getSearchRange(value);

  if (range.ceil === 0) {
    return '-';
  }
  return `${i18n.formatDecimal(range.floor, options)} - ${i18n.formatDecimal(range.ceil, options)}`;
}
